import * as locales from '@material-ui/core/locale';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const font = "'Inter UI', sans-serif";
export default function PACEThemeProvider(props) {

  const [t, i18n] = useTranslation()
  const [theme, setTheme] = useState(createMuiTheme())

  useEffect(() => {
    setupTheme()
  }, [i18n.language])

  function languageSwitcher() {
    switch (i18n.language) {
      case "en":
        return locales.enUS
      case "vi":
        return locales.viVN
      default:
        return locales.enUS
    }
  }

  function setupTheme() {
    const language = languageSwitcher()
    let theme = createMuiTheme({
      palette: {
        // type: 'dark',
        primary: {
          main: '#E71937',
        },
        secondary: {
          main: '#1F3B87',
        },
        font: {
          main: "#FFF"
        }
      },
      overrides: {
        MuiTablePagination: {
          toolbar: {
            borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
          }
        },
        MuiTableCell: {
          root: {
            fontSize: '12px',
          }
        },
        MuiTypography: {
          h5: {
            fontSize: '20px',
            fontWeight: '600',
          }
        },
        MuiListSubheader: {
          root: {
            textTransform: 'uppercase',
            fontSize: '12px',
            letterSpacing: '0.2px',
          }
        },
        MuiDrawer: {
          root: {
            paddingTop: '0px',
          }
        },
        MuiPaper: {
          root: {
            backgroundColor: "var(--bg)",
          },
          rounded: {
            borderRadius: "8px"
          }
        },
        MuiListSubheader: {
          root: {
            color: "var(--secondary-font)",
          }
        },
        MuiTableCell: {
          root: {
            color: "var(--secondary-font)",
          }
        },
        MuiFormControl: {
          marginDense: {
            marginBottom: "8px"
          }
        },
        MuiButton: {
          root: {
            borderRadius: "8px"
          }
        },
        PrivateNotchedOutline: {
          root: {
            borderRadius: "8px"
          }
        },
        MuiCardContent: {
          root: {
            "&:last-child": {
              paddingBottom: "16px"
            }
          }
        }

      },
      typography: {
        useNextVariants: true,
        fontFamily: '"Inter UI", Arial, Helvetica, sans-serif',
      },
      status: {
        danger: "orange"
      },
    }, language);

    theme.overrides.MuiTableCell = {
      root: {
        padding: '14px 30px 14px 30px',
        [theme.breakpoints.down('md')]: {
          padding: '14px 20px 14px 20px',
        }
      }
    };

    setTheme(theme)
  }

  return (
    <ThemeProvider theme={theme}>
      {props.children}
    </ThemeProvider>
  )
}
